import { Button } from "@/components/ui";
import { BodyText } from "@/components/ui/Text/BodyText";
import { HeaderText } from "@/components/ui/Text/HeaderText";
import { formatDateTime } from "@/lib/time";
import type { ServiceRequest } from "@curai/js-fhir-tools";
import { useMarkDiscussed } from "../../network/useMarkDiscussed";
import { useOrderResultHistoryAvailableActions } from "../../network/useOrderHistoryAvailableActions";

export const ResultsReviewHistory = ({
  patientId,
  serviceRequest,
  needsDiscussion,
}: {
  patientId: string;
  serviceRequest: ServiceRequest;
  needsDiscussion?: boolean;
}) => {
  const { mutate: markDiscussed, isPending: isMarkingDiscussed } =
    useMarkDiscussed({
      patientId,
      serviceRequestId: serviceRequest.id as string,
    });

  const { data: availableActions } =
    useOrderResultHistoryAvailableActions(patientId);

  return (
    <div className="flex flex-col">
      <HeaderText size="sm">Results Review</HeaderText>
      <BodyText size="sm">{serviceRequest.triageActivityActionLabel}</BodyText>
      <BodyText size="sm">{serviceRequest.triageActivityNote}</BodyText>

      {serviceRequest?.triageActivityPerformer && (
        <BodyText size="xs" textColor="tertiary">
          Results reviewed by {serviceRequest.triageActivityPerformer.display}{" "}
          on {formatDateTime(serviceRequest.triageActivityTriagedAt)}
        </BodyText>
      )}
      {needsDiscussion && availableActions?.markDiscussedAllowed && (
        <Button
          size="xs"
          variant="primary"
          className="w-fit mt-2 self-end"
          onClick={() => markDiscussed()}
          isLoading={isMarkingDiscussed}
        >
          Mark Discussion Complete
        </Button>
      )}
    </div>
  );
};
